export const userConstants = {
    REGISTER_REQUEST: 'REGISTER_REQUEST',
    REGISTER_SUCCESS: 'REGISTER_SUCCESS',
    REGISTER_FAILURE: 'REGISTER_FAILURE',
    REGISTER_DUPLICATE_EMAIL: 'REGISTER_DUPLICATE_EMAIL',

    GET_USER_DATA_REQEUST: 'GET_USER_DATA_REQUEST',
    GET_USER_DATA_SUCCESS: 'GET_USER_DATA_SUCCESS',
    GET_USER_DATA_FAILURE: 'GET_USER_DATA_FAILURE',

    UPDATE_USER_DATA_REQUEST: 'UPDATE_USER_DATA_REQUEST',
    UPDATE_USER_DATA_SUCCESS: 'UPDATE_USER_DATA_SUCCESS',
    UPDATE_USER_DATA_FAILURE: 'UPDATE_USER_DATA_FAILURE',

    UPLOAD_USER_LOGO_REQUEST: 'UPLOAD_USER_LOGO_REQUEST',
    UPLOAD_USER_LOGO_SUCCESS: 'UPLOAD_USER_LOGO_SUCCESS',
    UPLOAD_USER_LOGO_FAILURE: 'UPLOAD_USER_LOGO_FAILURE',

    DELETE_USER_LOGO_REQUEST: 'DELETE_USER_LOGO_REQUEST',
    DELETE_USER_LOGO_SUCCESS: 'DELETE_USER_LOGO_SUCCESS',
    DELETE_USER_LOGO_FAILURE: 'DELETE_USER_LOGO_FAILURE'
}


// WEBPACK FOOTER //
// ./src/constants/user.js